var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 60.533C68 68.541 56.36 76 42 76s-26-7.459-26-15.467C16 52.525 27.64 47 42 47s26 5.525 26 13.533"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 31,
    r: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.5c1537e6e3f7907ddece40f68b3beda1.svg";
export { ForwardRef as ReactComponent };